;(function () {
    // Sticky header functionality temporarily disabled
})()
